exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".operamini-tips[data-v-629e87d6]{background:#ff0;text-align:center;font-weight:700}.links[data-v-629e87d6]{font-size:14px;padding:0 15px;color:#fff}.links a[data-v-629e87d6]{color:#fff}", "", {"version":3,"sources":["/home/work/jenkins/workspace/beta-allfootball-msite/src/pages/AppNews.vue"],"names":[],"mappings":"AACA,iCACE,gBAAoB,AACpB,kBAAmB,AACnB,eAAkB,CACnB,AACD,wBACE,eAAgB,AAChB,eAAuB,AACvB,UAAY,CACb,AACD,0BACE,UAAY,CACb","file":"AppNews.vue","sourcesContent":["\n.operamini-tips[data-v-629e87d6] {\n  background: #FFFF00;\n  text-align: center;\n  font-weight: bold;\n}\n.links[data-v-629e87d6] {\n  font-size: 14px;\n  padding: 0 15px 0 15px;\n  color: #fff;\n}\n.links a[data-v-629e87d6] {\n  color: #fff;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-629e87d6","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/AppNews.vue
// module id = 712
// module chunks = 1